import { render, staticRenderFns } from "./ComparteGana.vue?vue&type=template&id=513bb11b&scoped=true"
import script from "./ComparteGana.vue?vue&type=script&lang=js"
export * from "./ComparteGana.vue?vue&type=script&lang=js"
import style0 from "./ComparteGana.vue?vue&type=style&index=0&id=513bb11b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513bb11b",
  null
  
)

export default component.exports